import { useState } from "react";
import { Field } from "formik";

import { ImageViewer } from "./ImageViewer";
import { ImageEditor } from "./ImageEditor";

const EMPTY_IMAGE = {
  x: 0.5,
  y: 0.5,
  rotate: 0,
  scale: 1,
  url: "",
  isEmpty: true
};

const normalizeImage = (image) => ({
  ...EMPTY_IMAGE,
  ...(image || {})
});

const ControlledImageInput = (props) => {
  const [open, setOpen] = useState(false);

  const image = normalizeImage(props.value);

  const onClick = () => {
    if (!props.disabled) {
      setOpen(true);
    }
  };

  const onOk = (changedImage) => {
    setOpen(false);

    if (props.onChange) {
      props.onChange(normalizeImage(changedImage));
    }
  };

  return (
    <span className={props.className || ""}>
      <ImageViewer
        image={image}
        width={props.width}
        height={props.height}
        borderRadius={props.borderRadius}
        className={props.viewerClassName}
        onClick={props.disabled ? undefined : onClick}
        emptyLabel={props.emptyLabel}
      />

      {!props.disabled ? (
        <ImageEditor
          image={image}
          open={open}
          onOk={onOk}
          onCancel={() => setOpen(false)}
        />
      ) : null}
    </span>
  );
};

export function ImageInput(props) {
  const controlled = Object.prototype.hasOwnProperty.call(props, "value");

  if (controlled) {
    return <ControlledImageInput {...props} />;
  }

  const [open, setOpen] = useState(false);

  const onClick = () => {
    if (!props.disabled) {
      setOpen(true);
    }
  };

  const onCancel = () => {
    setOpen(false);
  };

  const onOk = (changedImage, setFieldValue) => {
    const image = normalizeImage(changedImage);

    setFieldValue(props.name, image);
    setOpen(false);

    if (props.onChange) {
      props.onChange(image);
    }
  };

  return (
    <Field name={props.name} id={props.id || props.name}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <ImageViewer
            image={normalizeImage(value)}
            width={props.width}
            height={props.height}
            borderRadius={props.borderRadius}
            className={props.viewerClassName}
            onClick={props.disabled ? undefined : onClick}
            emptyLabel={props.emptyLabel}
          />

          {!props.disabled ? (
            <ImageEditor
              image={normalizeImage(value)}
              open={open}
              onOk={(changedImage) => onOk(changedImage, setFieldValue)}
              onCancel={onCancel}
            />
          ) : null}
        </>
      )}
    </Field>
  );
}
